import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectionChangedEvent, ColGroupDef, ColDef } from '@ag-grid-enterprise/all-modules';
import { SshSecurityInfo } from 'data/sshSecurityInfo/sshSecurityInfo.types';
import CommonGrid from 'shared/commonGrid';
import { ROWSELECTION } from 'shared/commonGrid/grid-enums';
import ActionMenuCellRenderer from 'shared/commonGrid/action-menu-cell-renderer';
import SshSecurityInfoGridActionMenu from '../SshSecurityInformationGridActionMenu';

interface Props {
  data: SshSecurityInfo[]
  hasPrivilegeToView: boolean
  hasPrivilegesToCreate: boolean
  hasPrivilegeToDelete: boolean
  noResults: boolean,
  beforeLogout: boolean,
  lastUpdatedAt: Date | undefined,
  columnDefs: (ColGroupDef | ColDef)[],
  selectedSshSecurityInfo: SshSecurityInfo,
  onRefresh: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onCreateNew: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  onSelectionChanged: (event: SelectionChangedEvent) => void
  onView: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

const SshSecurityInfoListGrid: FunctionComponent<Props> = ({
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  hasPrivilegeToView,
  data = [],
  noResults,
  beforeLogout,
  lastUpdatedAt,
  columnDefs,
  selectedSshSecurityInfo,
  onCreateNew,
  onRefresh,
  onSelectionChanged,
  onView,
  onEdit,
  onDelete,
}: Props) => {
  const components = {
    actionMenuCellRenderer: ActionMenuCellRenderer,
  };
  const { t } = useTranslation();

  return (
    <div className="grid-container" style={{ height: 'inherit' }} data-testid="SshSecurityInfoList">
      <CommonGrid
        createNewText={t('sshSecurityInfo.grid.newsshSecurityInfo')}
        pagination
        enableBrowserTooltips
        rowSelection={ROWSELECTION.SINGLE}
        hasPrivilegeToCreateNew={hasPrivilegesToCreate}
        hasPrivilegeToDelete={hasPrivilegeToDelete}
        hasPrivilegetoView={hasPrivilegeToView}
        rowData={data}
        noResults={noResults}
        isBeforeLogout={beforeLogout}
        columnDefs={columnDefs}
        components={components}
        handleCreateNew={onCreateNew}
        onRefresh={onRefresh}
        onSelectionChanged={onSelectionChanged}
        onActionMenuItemClick={onView}
        lastUpdatedAt={lastUpdatedAt}
      >
        <SshSecurityInfoGridActionMenu
          selectedItem={selectedSshSecurityInfo}
          hasPrivilegesToCreate={hasPrivilegesToCreate}
          hasPrivilegeToDelete={hasPrivilegeToDelete}
          onEdit={onEdit}
          onDelete={onDelete}
        />

      </CommonGrid>
    </div>
  );
};

export default SshSecurityInfoListGrid;
